import axios from "axios";
import type { InternalAxiosRequestConfig } from "axios";

import { Identity } from "models/Identity";
import * as storage from "../../context/Storage";

export const intercept = () => {
  axios.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => setUserHeaders(config),
    (error) => Promise.reject(error)
  );
};

export const setUserHeaders = (
  config: InternalAxiosRequestConfig
): InternalAxiosRequestConfig => {
  config.params &&
    Object.keys(config.params).forEach((key) => {
      if (config.params[key] === "" || config.params[key] === undefined) {
        delete config.params[key];
      }
    });

  config.headers = config.headers || {};

  if (!config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${(
      storage.local.getItem("accessToken") || ""
    ).trim()}`;
  }

  const idtoken = storage.local.getItem("id_token");

  if (idtoken) {
    const id: Identity = JSON.parse(idtoken);
    const isValidIdentity: boolean =
      id.scopeUser !== undefined && id.scopeRegion !== undefined;

    if (id.isAuthenticated && !isValidIdentity) {
      storage.local.removeItem("id_token");
      storage.local.removeItem("accessToken");
      storage.local.removeItem("userPreferences");
      console.error("Invalid region path login out");
      throw "Invalid region path";
    }
  }
  return config;
};
